<template>
  <!-- 150px, not 75: a real policy number is "18102-93164668" or "720456383", and the cell was half
       the width of its own column, so every one of them was ellipsed to a hover title. -->
  <div style="width: 150px" class="review-section__table-cell" :title="number">
    <a
      v-if="href"
      :href="href"
      target="_blank"
      class="body-text body-text--link color--purple"
    >{{ number }}</a>
    <span v-else>{{ number }}</span>
  </div>
</template>

<script>
import {policyHref} from './payments-review-utils';

export default {
  name: 'PaymentsReviewPolicyNumberCell',
  props: {
    row: {
      type: Object,
      required: true,
    },
  },
  computed: {
    number() {
      const value = this.row?.policyNumber;
      return value === null || value === undefined || value === '' ? '—' : String(value);
    },
    href() {
      return policyHref(this.row);
    },
  },
};
</script>
